/* eslint-disable */
import 'whatwg-fetch';
import WebFont from 'webfontloader';
import 'moment/locale/ru'; // Here import all possible moment locales
import 'react-hot-loader'; // https://github.com/gaearon/react-hot-loader#getting-started
import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import store from './store/store';
import Root from './components/Root';
import i18n from './i18n/i18n';
import { I18nextProvider } from 'react-i18next';
import './styles/index.scss';

const render = (Component) => {
  ReactDOM.render(
      <Provider store={store}>
        <BrowserRouter >
          <I18nextProvider i18n={i18n}>
              <Component />
          </I18nextProvider>
        </BrowserRouter>
      </Provider>,
    window.document.getElementById('app'),
  );
};

WebFont.load({
  custom: {
    families: ['Lato'],
  },
  active: () => {
    render(Root);

   try {
     window.parent.postMessage({ type: 'paycafe-active' }, '*');
   } catch (e) {
     console.error(e);
   }
  },
});
